var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-feed-section-content-footer"},[_c('span',[_vm._v("Creado con")]),_vm._m(0),_c('span',[_vm._v("© "+_vm._s(_vm.$moment().year()))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"text-link-hover-academy font-weight-bold",attrs:{"href":"https://vidroop.com/vidroop","target":"_blank"}},[_c('img',{attrs:{"src":require("@/assets/img/logo.png"),"alt":"Vidroop.com","height":"17"}})])
}]

export { render, staticRenderFns }